import { FETCH_COMPANIES as fetchCompanies } from "../../../../../graphql/query/Company";

const SearchedCompanies = () => {
  const tableProps = {
    dataKey: "companies",
    FETCH_QUERY: fetchCompanies({
      code: true,
      name: true,
      active: true,
      contact: {
        country: {},
      },
    }),
  };

  return tableProps;
};

export default SearchedCompanies;
